import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
  SelectField as MuiSelectField,
  MenuItem as MuiMenuItem
} from 'material-ui';

import { blueGray, solidWhite } from '../../../theme/colors';
import globalStyles from '../../../shared-styles/';

class HeightSelect extends Component {
  static propTypes = {
    heightUnit: PropTypes.string,
    displayHeight: PropTypes.shape({
      valueOne: PropTypes.number,
      valueTwo: PropTypes.number
    }).isRequired,
    setHeightOne: PropTypes.func,
    setHeightTwo: PropTypes.func,
    setHeightUnit: PropTypes.func
  };

  populateHeightOneValues() {
    let min;
    let max;
    let suffix;
    if (this.props.heightUnit === 'metric') {
      min = 0;
      max = 2;
      suffix = 'm';
    } else {
      min = 3;
      max = 8;
      suffix = 'ft';
    }
    const values = _.range(min, max + 1);
    return values.map((value) => {
      return (
        <MuiMenuItem
          value={ value }
          key={ String(value) }
          primaryText={ `${String(value)} ${suffix}` }
          style={{ textAlign: 'center' }}
        />
      );
    });
  }

  populateHeightTwoValues() {
    let min;
    let max;
    let suffix;
    if (this.props.heightUnit === 'metric') {
      min = 0;
      max = 99;
      suffix = 'cm';
    } else {
      min = 0;
      max = 11;
      suffix = 'in';
    }
    const values = _.range(min, max + 1);
    return values.map((value) => {
      return (
        <MuiMenuItem
          value={ value }
          key={ String(value) }
          primaryText={ `${String(value)} ${suffix}` }
          style={{ textAlign: 'center' }}
        />
      );
    });
  }

  render() {
    return (
      <div className="height-select">
        <Grid fluid>
          <Row className="height-select-row">
            <Col xs={ 4 }>
              <MuiSelectField
                className="height-select-input user-profile-select-input"
                value={ this.props.displayHeight.valueOne }
                autoWidth={ true }
                fullWidth={ true }
                onChange={ this.props.setHeightOne }
                iconStyle={{ display: 'none' }}
                labelStyle={{ ...globalStyles.selectLabelStyle, color: solidWhite }}
                hintStyle={ globalStyles.selectHintStyle }
                selectedMenuItemStyle={{
                  color: blueGray,
                  fontWeight: 600
                }}
                dropDownMenuProps={{
                  targetOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                  }
                }}
                maxHeight={ 400 }
              >
                {this.populateHeightOneValues()}
              </MuiSelectField>
            </Col>
            <Col xs={ 4 }>
              <MuiSelectField
                className="height-select-input user-profile-select-input"
                value={ this.props.displayHeight.valueTwo }
                autoWidth={ true }
                fullWidth={ true }
                onChange={ this.props.setHeightTwo }
                iconStyle={{ display: 'none' }}
                labelStyle={{ ...globalStyles.selectLabelStyle, color: solidWhite }}
                hintStyle={ globalStyles.selectHintStyle }
                selectedMenuItemStyle={{
                  color: blueGray,
                  fontWeight: 600
                }}
                dropDownMenuProps={{
                  targetOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                  }
                }}
                maxHeight={ 400 }
              >
                {this.populateHeightTwoValues()}
              </MuiSelectField>
            </Col>
            <Col xs={ 4 }>
              <MuiSelectField
                className="height-select-input user-profile-select-input"
                value={ this.props.heightUnit }
                autoWidth={ true }
                fullWidth={ true }
                onChange={ this.props.setHeightUnit }
                iconStyle={{ display: 'none' }}
                labelStyle={{ ...globalStyles.selectLabelStyle, color: solidWhite }}
                hintStyle={ globalStyles.selectHintStyle }
                selectedMenuItemStyle={{
                  color: blueGray,
                  fontWeight: 600
                }}
                dropDownMenuProps={{
                  targetOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                  }
                }}
                maxHeight={ 400 }
              >
                <MuiMenuItem primaryText="Metric" value="metric" />
                <MuiMenuItem primaryText="US" value="standard" />
              </MuiSelectField>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default HeightSelect;
